// Только сигнал обновления: токены и персональные данные не записываются.
export const ACCESS_UPDATE_KEY = 'planium:access-updated';
export function notifyAccessChanged() {
  window.dispatchEvent(new Event('access:changed'));
  try { localStorage.setItem(ACCESS_UPDATE_KEY, `${Date.now()}:${Math.random()}`); } catch { /* Обновление в текущей вкладке уже отправлено. */ }
}